import React, { FC, useEffect, useMemo, useRef } from "react";
import { OrganizationsListItemProps } from "./OrganizationsListItem.types";
import { useState } from "./";
import { ReactComponent as TickIcon } from "images/OrganizationTickIcon.svg";
import { ReactComponent as TrashCan } from "images/TrashCan.svg";
import { ReactComponent as RefreshIcon } from "images/Refresh.svg";
import { ReactComponent as ThreeDotsIcon } from "images/ThreeDots.svg";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import {
	archiveOrganization,
	restoreOrganization,
} from "toolkit/organizations/organizations.thunks";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import Badge from "components-new/Badge";
import CustomLinkForAccept from "components/CustomLink/CustomLink";
import "./OrganizationsListItem.styles.sass";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { DeleteWindow } from "pages/DocumentsPage/Folders/DeleteWindow/DeleteWindow";
import { ChangeAddingOrg } from "toolkit/organizations/organizations.slice";
import { useTracking } from "hooks/useTracking";

export const OrganizationsListItem: FC<OrganizationsListItemProps> = ({ organization, last, parentRef }) => {
	const { organizationsList, mode, searchMode, archiveMode, addingOrg } = useAppSelector(
		(state) => state.organizations,
	);
	const [displayingSubsidiaries, setDisplayingSubsidiaries] = useState<boolean>(false);
	const dispatch = useAppDispatch();
	const [menu, setMenu] = useState<boolean>(false);
	const orgRef: any = useRef(null);
	const menuRef = useRef(null);
	const [modalWindow, setModalWindow] = useState<any>({
		content: null,
		visibility: false,
	});

	useEffect(() => {
		if (displayingSubsidiaries && !organization.childrenCount && !searchMode) setDisplayingSubsidiaries(false);
		//eslint-disable-next-line
	}, [organization.childrenCount]);

	useOutsideAlerter(menuRef.current, () => setMenu(false));
	// const location = useLocation();

	// const isCategorization = useMemo(() => {
	// 	return /categorization/.test(location.pathname);
	// }, [location.pathname]);

	const displayingSubsidiariesHandler = () => {
		// if (!organizationsList.some((item) => item.parent?.id === organization.id)) {
		// 	dispatch(getChildrenOrganization({ id: organization.id, isCategorization }));
		// }
		setDisplayingSubsidiaries(!displayingSubsidiaries);
	};

	const openMenu = () => {
		if (menu) return;
		setTimeout(() => {
			setMenu((prev) => !prev);
		}, 1);
	};
	// разворачиание списка организаций при добавлении и прокрутка к добавленной организации
	useEffect(() => {
		if (searchMode || !addingOrg) return;
		if (
			(organization.id === organizationsList[organizationsList.length - 1].parent?.id && organization.childrenCount) ||
			(organization.type.name === "Головная организация" && organization.childrenCount)
		) {
			setDisplayingSubsidiaries(true);
		}
		//eslint-disable-next-line
	}, [addingOrg, displayingSubsidiaries]);

	useTracking(
		orgRef,
		[addingOrg, displayingSubsidiaries],
		Boolean(organization.id === organizationsList[organizationsList.length - 1].id && addingOrg),
		250,
		() => dispatch(ChangeAddingOrg(false)),
	);

	// Открытие дочерних элементов сразу
	useEffect(() => {
		// if (organization.nesting === 1 && organization.childrenCount) {}
		if (organization.childrenCount && !archiveMode && !searchMode) displayingSubsidiariesHandler();
		//eslint-disable-next-line
	}, []);

	const legendList = {
		"Головная организация": "main",
		"Головная компания": "main",
		"Дочерняя компания": "subsidiary",
		"Дочерняя организация": "subsidiary",
		"Филиал": "branch",
		"Обособленное подразделение": "division",
	};

	const filterAndSortlist = useMemo(() => {
		return organizationsList
			.filter((item) => item.parent?.id === organization.id)
			.sort((a, b) => a.type.positionIndex - b.type.positionIndex);
		//eslint-disable-next-line
	}, [displayingSubsidiaries, organizationsList]);

	const openModalWindow = (component: React.ReactElement) => {
		setModalWindow({ ...modalWindow, content: component, visibility: true });
		setMenu(false);
	};

	const closeModalWindow = () => {
		setModalWindow({ ...modalWindow, content: null, visibility: false });
	};

	const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		dispatch(archiveOrganization({ org: organization }));
		closeModalWindow();
	};

	const restoreHandler = () => {
		dispatch(restoreOrganization({ org: organization }));
		setMenu(false);
	};

	return (
		<>
			{modalWindow.visibility && <ModalWindow close={closeModalWindow}>{modalWindow.content}</ModalWindow>}
			<tr
				// onClick={() => alert(last)}
				ref={orgRef}
				className={`organizations-table-body-row ${displayingSubsidiaries && "organizations-table-body-row-actived"}`}>
				<th
					className={`organizations-table-body-row-item ${
						!searchMode && !archiveMode ? `nesting-${organization.nesting}` : ""
					}`}>
					<div className="organizations-table-body-row-item-wrp">
						<div
							className={`item-type item-type-${legendList[organization.type.name as keyof typeof legendList]}`}/>
						{organization.type.name !== "Обособленное подразделение" &&
							organization.type.name !== "Филиал" &&
							!searchMode &&
							!archiveMode && (
								<>
									<input
										checked={displayingSubsidiaries}
										className="input-type none"
										onChange={displayingSubsidiariesHandler}
										type="checkbox"
										id={`${organization.id}`}
									/>
									<label
										htmlFor={`${organization.id}`}
										className={`organizations-table-body-row-item-tick-wrp ${
											organization.childrenCount > 0 ? "" : "tick-disabled"
										}`}>
										<TickIcon className={`organizations-table-body-row-item-tick `} />
									</label>
								</>
							)}
						<CustomLinkForAccept
							errorText={"У вас недостаточно прав для просмотра категорирования этой организации"}
							state={{ title: organization.fullName }}
							switched={organization.accessible || organization.accessible === null}
							url={
								mode === "categorization"
									? `/categorization/organizations/${organization.id}/steps`
									: `/organization/${organization.id}`
							}
							linkStyle="organizations-table-body-row-item-link">
							{organization.shortName}&nbsp;
							{organization.type.name !== "Обособленное подразделение" &&
								organization.type.name !== "Филиал" &&
								!searchMode &&
								!archiveMode &&
								`(${organization.childrenCount})`}
						</CustomLinkForAccept>
					</div>
				</th>
				<th className="organizations-table-body-row-item">{organization.inn || "—"}</th>
				<th className="organizations-table-body-row-item">{organization.kpp || "—"}</th>
				<th className="organizations-table-body-row-item">{organization.ogrn || "—"}</th>
				{/* <th className="organizations-table-body-row-item">{organization.okiiStatus || ""}</th> */}
				<th className="organizations-table-body-row-item"></th>
				<th className="organizations-table-body-row-item markers-cell">
					{organization.markers.length ? (
						<div className="markers">
							{organization.markers.map((marker) => (
								<div key={marker.id} className="marker">
									<Badge color={marker.colorCode || ""}>{marker.abbreviation || marker.name}</Badge>
								</div>
							))}
						</div>
					) : (
						<div className="empty">—</div>
					)}
					{mode !== "categorization" && (
						<>
							<button onClick={openMenu} className="menu-btn">
								<ThreeDotsIcon />
							</button>
							<div ref={menuRef} className="menu-wrp">
								{menu && (
									<div onClick={(e) => e.stopPropagation()} className={`menu ${last ? "menu-top" : ""}`}>
										{archiveMode ? (
											<div onClick={restoreHandler} className="menu-item">
												<div className="icon-wrp">
													<RefreshIcon className="refresh" />
												</div>
												<span className="menu-item-txt">Восстановить</span>
											</div>
										) : (
											<div
												onClick={() =>
													openModalWindow(
														<DeleteWindow
															subtitle="Организация переместится в архив"
															onSubmit={(e) => submitHandler(e)}
															close={closeModalWindow}
														/>,
													)
												}
												// className={`menu-item ${
												// 	organization.childrenCount > 0 || organization.type.name === "Головная организация"
												// 		? "menu-item-disabled"
												// 		: ""
												// }`}>
												className="menu-item">
												<div className="icon-wrp">
													<TrashCan className="trashCan" />
												</div>
												<span className="menu-item-txt">В архив</span>
											</div>
										)}
									</div>
								)}
							</div>
						</>
					)}
				</th>
			</tr>
			{displayingSubsidiaries &&
				filterAndSortlist.map((organization, i) => (
					<OrganizationsListItem
						key={organization.id}
						organization={organization}
						last={i === filterAndSortlist.length - 1}
						parentRef={parentRef}
					/>
				))}
		</>
	);
};
